// The pin of a client location's map (views/clients/client-location-edit.js). A new location opens on its
// country (the client's, else the company's), with the pin at the country's centre; the admin drags the pin,
// or clicks the map, to the exact spot of the site, and it is not saved until they have. An existing location
// opens on its saved pin.

export const PIN_HINT = 'Drag the pin, or click the map, to mark the exact spot of the site.';
export const PIN_NOT_MOVED = 'Please move the pin to the exact spot of the site.';

// Zoom of an existing location's saved pin, close enough to drag it to the exact spot
export const SITE_ZOOM = 15;

function code(value) {
	return typeof value === 'string' && /^[A-Za-z]{2}$/.test(value.trim()) ? value.trim().toUpperCase() : null;
}

// The country a new location's map opens on: the client's, else the company's; null when neither is known
export function startCountry(clientCountry, companyCountry) {
	return code(clientCountry) || code(companyCountry);
}

// The refusal of a Save, or null: a new location's pin must have been moved
export function pinRefusal(isNew, pinMoved) {
	return isNew && !pinMoved ? PIN_NOT_MOVED : null;
}

// A typed latitude and longitude, as numbers, or null while they are not a valid spot
export function typedSpot(latitude, longitude) {
	const blank = (v) => v === null || v === undefined || String(v).trim() === '';
	if (blank(latitude) || blank(longitude)) {
		return null;
	}
	const lat = Number(latitude);
	const lng = Number(longitude);
	if (!Number.isFinite(lat) || !Number.isFinite(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
		return null;
	}
	return { lat, lng };
}

// A spot from the map, rounded to 6 decimals (about 10 cm)
export function roundedSpot(lat, lng) {
	return { lat: Number(Number(lat).toFixed(6)), lng: Number(Number(lng).toFixed(6)) };
}
